import react from "react";
import styles from "./EmptyCourse.module.css";
import EmptyCourseIcon from "./EmptyCourseIcon.png";
import Image from "next/image";
import Buttons from "../Button/Button";

function EmptyCourse(props) {
  return (
    <>
      {props.MainTitle &&
        <div className={styles.MainTitle}>Courses</div>
      }
      <div className={styles.Container}>
        <div className={styles.ContainerInner}>
          <Image className={styles.Icon} src={EmptyCourseIcon} />
          <div className={styles.Title}>{props.Title}</div>
          <div className={styles.Description}>{props.Description}</div>
        </div>
      </div>
    </>
  );
}

export default EmptyCourse;


